import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, ClipboardCheck } from 'lucide-react';
import RisposteInviate from '../../components/survey/RisposteInviate';
import { useRisposteInviate } from '../../hooks/useRisposteInviate';
import { percorsiArea } from '../../services/surveyAuth';
import { removeRepresentativeToken } from '../../services/representativeService';
import { useProfiloRappresentante } from './AssociativeCircolari';
import { ShellSondaggi } from './AssociativeSurveys';

/**
 * Area associativa: risposte inviate dal rappresentante a un sondaggio
 * completato, in sola lettura (Bearer rappresentante), nella shell dei sondaggi.
 * Sessione non più valida: token rimosso e ritorno all'accesso.
 */

const percorsi = percorsiArea('associativa');

const AssociativeSurveyAnswers: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const profile = useProfiloRappresentante();
  const { stato, survey, response, messaggio } = useRisposteInviate(id, 'associativa');

  useEffect(() => {
    if (stato !== 'sessione') return;
    removeRepresentativeToken();
    navigate('/accesso-associati', { replace: true, state: { from: id ? percorsi.risposte(id) : percorsi.elenco } });
  }, [stato, id, navigate]);

  let contenuto: React.ReactNode;
  if (stato === 'caricamento' || stato === 'sessione') {
    contenuto = (
      <div className="muted" style={{ textAlign: 'center', padding: '40px 0', fontSize: '13px' }}>Caricamento…</div>
    );
  } else if (stato === 'ok' && survey && response) {
    contenuto = <RisposteInviate survey={survey} response={response} cornice={false} />;
  } else if (stato === 'nessuna') {
    contenuto = (
      <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-6">
        Nessuna risposta inviata per questo sondaggio
      </p>
    );
  } else {
    contenuto = (
      <p role="alert" className="text-sm text-red-600 dark:text-red-400 text-center py-6">
        {messaggio || 'Impossibile caricare le risposte. Riprova più tardi.'}
      </p>
    );
  }

  return (
    <ShellSondaggi profile={profile}>
      <div className="page fade-in">
        <header style={{ marginBottom: 18 }}>
          <h1 className="text-base font-semibold text-gray-900 dark:text-white">Risposte inviate</h1>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
            Le risposte che hai inviato, in sola lettura
          </p>
        </header>
        <section className="card">
          <div className="card-head">
            <ClipboardCheck size={16} />
            <h2>Le tue risposte</h2>
          </div>
          <div className="card-body">{contenuto}</div>
        </section>
        <button
          type="button"
          className="btn ghost sm"
          style={{ marginTop: 16 }}
          onClick={() => navigate(percorsi.elenco)}
        >
          <ArrowLeft size={14} aria-hidden="true" /> Torna ai sondaggi
        </button>
      </div>
    </ShellSondaggi>
  );
};

export default AssociativeSurveyAnswers;
